/* Bergblut Winterfeuer — <bbw-box>
   Drehbarer Karton in reinem CSS-3D (kein three.js).
   Die sechs Flaechenbilder kommen als Attribute aus Liquid:
   tex1..tex6 (Bild) und mask1/mask2/mask5 (Kupfer-Masken).
   Vorlage: design_handoff_winterfeuer_adventskalender/wf-3d.js */
(function () {
  if (window.customElements && customElements.get('bbw-box')) return;

  var CSS = [
    'bbw-box{display:block;position:relative;width:100%}',
    '.bbw3-stage{position:relative;width:100%;height:100%;min-height:340px;perspective:2900px;perspective-origin:50% 45%;display:flex;align-items:center;justify-content:center;cursor:grab;touch-action:none}',
    '.bbw3-stage.drag{cursor:grabbing}',
    '.bbw3-shadow{position:absolute;left:50%;top:50%;background:radial-gradient(ellipse at 50% 50%,rgba(0,0,0,.72) 0%,rgba(0,0,0,.4) 40%,rgba(0,0,0,0) 72%);filter:blur(14px);pointer-events:none}',
    '.bbw3-box{position:relative;transform-style:preserve-3d;will-change:transform}',
    '.bbw3-box .face{position:absolute;left:50%;top:50%;overflow:hidden;background-size:100% 100%;background-repeat:no-repeat;backface-visibility:hidden;-webkit-backface-visibility:hidden;box-shadow:inset 0 0 0 1px rgba(255,255,255,.045)}',
    '.bbw3-box .lay{position:absolute;inset:0;pointer-events:none;-webkit-mask-size:100% 100%;mask-size:100% 100%;-webkit-mask-repeat:no-repeat;mask-repeat:no-repeat}',
    '.bbw3-box .shade{mix-blend-mode:multiply;background-image:linear-gradient(174deg,#fffaf4 0%,#f6ddc6 30%,#c4855c 72%,#88502a 100%)}',
    '.bbw3-box .sheen{mix-blend-mode:screen;background-repeat:no-repeat;background-size:300% 100%;background-image:linear-gradient(101deg,rgba(255,238,214,0) 30%,rgba(255,243,225,.55) 42%,rgba(255,250,240,.95) 48%,rgba(255,255,255,1) 50%,rgba(255,246,230,.9) 52%,rgba(255,235,205,.5) 58%,rgba(255,225,190,0) 70%)}',
    '.bbw3-box .grain{mix-blend-mode:overlay;opacity:.34;background-image:repeating-linear-gradient(97deg,rgba(255,255,255,.055) 0 1px,rgba(0,0,0,.05) 1px 2px)}',
    '.bbw3-box .edge{position:absolute;inset:0;pointer-events:none;box-shadow:inset 0 0 26px rgba(0,0,0,.34),inset 1px 0 0 rgba(255,255,255,.055),inset -1px 0 0 rgba(255,255,255,.055)}'
  ].join('');

  var FACES = [
    { w: 279, h: 344, pos: [0, 0, 69],     rot: 'rotateY(0deg)',    n: [0, 0, 1],  u: [1, 0, 0],  tex: 'tex1', mask: 'mask1' },
    { w: 279, h: 344, pos: [0, 0, -69],    rot: 'rotateY(180deg)',  n: [0, 0, -1], u: [-1, 0, 0], tex: 'tex2', mask: 'mask2' },
    { w: 138, h: 344, pos: [139.5, 0, 0],  rot: 'rotateY(90deg)',   n: [1, 0, 0],  u: [0, 0, -1], tex: 'tex3' },
    { w: 138, h: 344, pos: [-139.5, 0, 0], rot: 'rotateY(-90deg)',  n: [-1, 0, 0], u: [0, 0, 1],  tex: 'tex4' },
    { w: 279, h: 138, pos: [0, -172, 0],   rot: 'rotateX(90deg)',   n: [0, -1, 0], u: [1, 0, 0],  tex: 'tex5', mask: 'mask5' },
    { w: 279, h: 138, pos: [0, 172, 0],    rot: 'rotateX(-90deg)',  n: [0, 1, 0],  u: [1, 0, 0],  flat: 'rgb(24,39,55)' }
  ];

  var VIEWS = { cover: [-11, -27], front: [-9, -64], back: [-9, 116], lid: [-49, -31] };
  var W = 279, D = 138, H = 344;

  function nrm(v) { var l = Math.hypot(v[0], v[1], v[2]) || 1; return [v[0] / l, v[1] / l, v[2] / l]; }
  function add(a, b) { return [a[0] + b[0], a[1] + b[1], a[2] + b[2]]; }
  function dot(a, b) { return a[0] * b[0] + a[1] * b[1] + a[2] * b[2]; }
  function sub(a, b) { return [a[0] - b[0], a[1] - b[1], a[2] - b[2]]; }
  function mul(a, s) { return [a[0] * s, a[1] * s, a[2] * s]; }
  function rotv(v, rx, ry) {
    var a = ry * Math.PI / 180, b = rx * Math.PI / 180;
    var x = v[0] * Math.cos(a) + v[2] * Math.sin(a), y = v[1], z = -v[0] * Math.sin(a) + v[2] * Math.cos(a);
    return [x, y * Math.cos(b) - z * Math.sin(b), y * Math.sin(b) + z * Math.cos(b)];
  }
  var Ldir = nrm([-0.42, 0.72, 0.86]), Fdir = nrm([0.78, 0.26, 0.56]), Hh = nrm(add(Ldir, [0, 0, 1]));

  function BbwBox() { return Reflect.construct(HTMLElement, [], BbwBox); }
  BbwBox.prototype = Object.create(HTMLElement.prototype);
  BbwBox.prototype.constructor = BbwBox;
  Object.setPrototypeOf(BbwBox, HTMLElement);

  BbwBox.prototype.connectedCallback = function () {
    if (this._up) return; this._up = true;
    var self = this;

    if (!document.getElementById('bbw3-style')) {
      var st = document.createElement('style'); st.id = 'bbw3-style'; st.textContent = CSS;
      document.head.appendChild(st);
    }

    var stage = document.createElement('div'); stage.className = 'bbw3-stage';
    var shadow = document.createElement('div'); shadow.className = 'bbw3-shadow';
    var box = document.createElement('div'); box.className = 'bbw3-box';

    FACES.forEach(function (f) {
      var el = document.createElement('div'); el.className = 'face';
      var texUrl = f.tex ? self.getAttribute(f.tex) : null;
      if (f.flat || !texUrl) el.style.background = f.flat || 'rgb(24,39,55)';
      else el.style.backgroundImage = 'url("' + texUrl + '")';
      var maskUrl = f.mask ? self.getAttribute(f.mask) : null;
      if (maskUrl) {
        ['shade', 'grain', 'sheen'].forEach(function (k) {
          var l = document.createElement('div'); l.className = 'lay ' + k;
          l.style.webkitMaskImage = l.style.maskImage = 'url("' + maskUrl + '")';
          el.appendChild(l);
        });
      }
      var e = document.createElement('div'); e.className = 'edge'; el.appendChild(e);
      el._f = f; box.appendChild(el);
    });

    stage.appendChild(shadow); stage.appendChild(box); this.appendChild(stage);
    this._stage = stage; this._box = box; this._shadow = shadow;
    this._faces = Array.prototype.slice.call(box.querySelectorAll('.face'));

    var v = VIEWS[this.getAttribute('view')] || VIEWS.cover;
    this.rx = v[0]; this.ry = v[1]; this.tRx = v[0]; this.tRy = v[1]; this.easing = false;
    this.spin = this.hasAttribute('spin') && !matchMedia('(prefers-reduced-motion: reduce)').matches;

    this._bind(); this._layout(); this._render();
    this._ro = new ResizeObserver(function () { self._layout(); self._render(); });
    this._ro.observe(stage);

    var loop = function () {
      self._raf = requestAnimationFrame(loop);
      if (self.easing) {
        self.rx += (self.tRx - self.rx) * 0.1; self.ry += (self.tRy - self.ry) * 0.1;
        if (Math.abs(self.tRx - self.rx) < 0.05 && Math.abs(self.tRy - self.ry) < 0.05) {
          self.rx = self.tRx; self.ry = self.tRy; self.easing = false;
        }
        self._render();
      } else if (self.spin && !self._down && self._visible !== false) {
        self.ry += 0.17; self._render();
      }
    };
    loop();

    this._io = new IntersectionObserver(function (es) { self._visible = es[0].isIntersecting; }, { threshold: 0 });
    this._io.observe(this);
  };

  BbwBox.prototype.disconnectedCallback = function () {
    cancelAnimationFrame(this._raf);
    if (this._ro) this._ro.disconnect();
    if (this._io) this._io.disconnect();
  };

  BbwBox.prototype._bind = function () {
    var s = this._stage, self = this, px = 0, py = 0;
    s.addEventListener('pointerdown', function (e) {
      self._down = true; self.easing = false; self.setSpin(false);
      px = e.clientX; py = e.clientY; s.classList.add('drag');
      try { s.setPointerCapture(e.pointerId); } catch (err) {}
    });
    s.addEventListener('pointermove', function (e) {
      if (!self._down) return;
      self.ry += (e.clientX - px) * 0.42; self.rx -= (e.clientY - py) * 0.26;
      self.rx = Math.max(-72, Math.min(46, self.rx));
      px = e.clientX; py = e.clientY; self._render();
    });
    ['pointerup', 'pointercancel', 'pointerleave'].forEach(function (t) {
      s.addEventListener(t, function () { self._down = false; s.classList.remove('drag'); });
    });
  };

  BbwBox.prototype._layout = function () {
    var r = this._stage.getBoundingClientRect();
    var mm = Math.min(r.width / (W + D + 120), r.height / (H + 120));
    mm = Math.max(0.35, Math.min(mm, 2.0)); this._mm = mm;
    this._faces.forEach(function (el) {
      var f = el._f, fw = f.w * mm, fh = f.h * mm;
      el.style.width = fw + 'px'; el.style.height = fh + 'px';
      el.style.marginLeft = (-fw / 2) + 'px'; el.style.marginTop = (-fh / 2) + 'px';
      el._t = 'translate3d(' + (f.pos[0] * mm).toFixed(2) + 'px,' + (f.pos[1] * mm).toFixed(2) + 'px,' + (f.pos[2] * mm).toFixed(2) + 'px) ' + f.rot;
      el.style.transform = el._t;
    });
    var sh = this._shadow;
    sh.style.width = ((W + 40) * mm) + 'px'; sh.style.marginLeft = (-(W + 40) * mm / 2) + 'px';
    sh.style.top = 'calc(50% + ' + ((H / 2 + 18) * mm) + 'px)';
    sh.style.height = (70 * mm) + 'px'; sh.style.marginTop = (-35 * mm) + 'px';
  };

  BbwBox.prototype._render = function () {
    var rx = this.rx, ry = this.ry, self = this;
    this._box.style.transform = 'rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
    this._shadow.style.opacity = (0.55 + 0.25 * Math.cos(rx * Math.PI / 180)).toFixed(2);
    var order = [];
    this._faces.forEach(function (el) {
      var f = el._f, n = rotv(f.n, rx, ry);
      el.style.display = n[2] > 0.015 ? '' : 'none';
      order.push([rotv(f.pos, rx, ry)[2], el]);
      var br = Math.min(1.3, 0.71 + 0.42 * Math.max(0, dot(n, Ldir)) + 0.19 * Math.max(0, dot(n, Fdir)));
      el.style.filter = 'brightness(' + br.toFixed(3) + ')';
      var sn = el.querySelector('.sheen'); if (!sn) return;
      var u = rotv(f.u, rx, ry);
      var spec = Math.pow(Math.max(0, dot(n, Hh)), 9);
      var ht = sub(Hh, mul(n, dot(Hh, n)));
      var pu = Math.max(-1, Math.min(1, dot(ht, u) * 1.5));
      sn.style.backgroundPosition = (50 - pu * 46).toFixed(1) + '% 50%';
      sn.style.opacity = (0.22 + 0.85 * spec).toFixed(3);
    });
    order.sort(function (a, b) { return a[0] - b[0]; });
    var key = order.map(function (o) { return self._faces.indexOf(o[1]); }).join(',');
    if (key !== this._order) {
      this._order = key;
      order.forEach(function (o) { self._box.appendChild(o[1]); });
    }
  };

  BbwBox.prototype.setSpin = function (s) { this.spin = !!s; };
  BbwBox.prototype.setView = function (v) {
    var t = VIEWS[v] || VIEWS.cover; this.setSpin(false);
    this.tRx = t[0];
    var d = ((t[1] - this.ry) % 360 + 540) % 360 - 180;
    this.tRy = this.ry + d; this.easing = true;
  };

  customElements.define('bbw-box', BbwBox);
})();
